import type { ReactNode } from 'react';

import { StaggerItem } from '@/shared/ui/animations';

interface SplitHeaderV2Props {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

/**
 * Section header for the redesigned IQ report. Titles centre because the report
 * actions moved up to the page header, leaving the heading alone on its row.
 * The `actions` slot is kept for callers that still pass one; it sits to the
 * right and pulls the heading back off centre, which is why IQ passes none.
 */
export const SplitHeaderV2 = ({ title, subtitle, actions }: SplitHeaderV2Props) => (
  <header className="flex items-center justify-between gap-4 pt-16 pb-5">
    <StaggerItem index={0} variant="swipeUp" className="flex-1">
      <div className="flex flex-col items-center gap-0.5 text-center">
        <h1 className="text-[32px] font-medium leading-[40px] tracking-[-0.32px] text-foreground text-pretty">
          {title}
        </h1>
        {subtitle && <p className="text-body-md text-foreground-subtle">{subtitle}</p>}
      </div>
    </StaggerItem>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </header>
);
